import React from 'react';
import { useResourceDefinitions, MenuItemLink } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Divider,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Folder, ExpandLess, ExpandMore, PersonAdd } from '@mui/icons-material';

export const CustomMenu = () => {
  const resources = useResourceDefinitions();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const allResources = Object.keys(resources).filter(
    name => name !== 'datastream'
  );

  const handleRegisterClick = () => {
    navigate('/register-client');
  };

  return (
    <Box sx={{ minWidth: 250 }}>
      {/* Desplegable Apartados */}
      <ListItem
        onClick={handleClick}
        sx={{
          '&:hover': {
            backgroundColor: 'action.hover',
            cursor: 'pointer',
          },
        }}
      >
        <ListItemIcon>
          <Folder />
        </ListItemIcon>
        <ListItemText primary='Funcionalidades' />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding>
          {allResources.map(name => (
            <MenuItemLink
              key={name}
              to={`/${name}`}
              primaryText={resources[name].options?.label || name}
              leftIcon={
                resources[name].icon
                  ? React.createElement(resources[name].icon)
                  : undefined
              }
            />
          ))}
        </List>
      </Collapse>

      <Divider
        sx={{ my: 2, mx: 2, borderColor: 'rgba(255, 255, 255, 0.12)' }}
      />

      {/* Darse de Alta */}
      <MenuItemLink
        to='/register-client'
        primaryText='Alta Cliente'
        leftIcon={<PersonAdd />}
        onClick={handleRegisterClick}
      />

      {/* Divisor visual */}
      <Divider
        sx={{ my: 2, mx: 2, borderColor: 'rgba(255, 255, 255, 0.12)' }}
      />

      {/* Etiqueta opcional para la sección separada */}
      <Typography
        variant='caption'
        sx={{
          px: 2,
          py: 1,
          display: 'block',
          color: 'text.secondary',
          textTransform: 'uppercase',
          fontSize: '0.7rem',
          fontWeight: 600,
          letterSpacing: 1,
        }}
      >
        Herramientas
      </Typography>

      {/* DataStream separado */}
      {resources['datastream'] && (
        <Box>
          <MenuItemLink
            to='/datastream'
            primaryText={resources['datastream'].options?.label || 'DataStream'}
            leftIcon={
              resources['datastream'].icon
                ? React.createElement(resources['datastream'].icon)
                : undefined
            }
          />
        </Box>
      )}
    </Box>
  );
};
